// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ddj-pdf-spinner',
    templateUrl: './ddj-pdf-spinner.component.html',
    styleUrls: ['./ddj-pdf-spinner.component.scss'],
})
export class DdjPDFSpinnerComponent implements OnInit {
    phrases = ['Gathering Document Information', 'Loading Signatures', 'Generating Signature Tool', 'Almost Finished'];

    constructor(protected readonly activatedRoute: ActivatedRoute) {}

    ngOnInit(): void {
        //add routes / check route
        const route = this.activatedRoute.snapshot.url;
        // update phrases based on route
        if (route.find((a) => a.path === 'view')) {
            this.phrases = ['Retrieving the Document From the DDJ Secure Vault', 'Sending the Document to Your Device Browser', 'Almost Complete…'];
        }
        this.changePhrase(this.phrases);
    }

    changePhrase(arr) {
        const phrase = document.getElementById('phrase');
        for (let i = 0; i < arr.length; i++) {
            // for each iteration console.log a word
            // and make a pause after it

            (function (i) {
                setTimeout(function () {
                    if (arr[i].length <= 0) {
                        arr = [''];
                    } else {
                        phrase.innerHTML = arr[i];
                    }
                }, 2500 * i);
            })(i);
        }
    }
}
